import React, { useState } from 'react'
import ContactForm from './ContactForm';
import { Helmet } from 'react-helmet-async';


export default function QueryForm() {
   
    return (
        <>
        <Helmet>
  <meta name="robots" content="noindex, nofollow" />
</Helmet>
        <div className="query-banner">
        <img src="/images/hero__3.jpg"  loading="lazy" alt="seventh-sense-images" />
        <span className='query-image dine'>Enquire Now</span>
         </div>

            <div className="container query-main-container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="querypageImage">
                    </div>

                    </div>

                   <ContactForm/>
                </div>
            </div>

        </>
    )
}
